import React from 'react';
import type {DateRange, PickersShortcutsItem} from '@mui/x-date-pickers-pro';
import {DateRangePicker, LocalizationProvider} from '@mui/x-date-pickers-pro';
import {AdapterDayjs} from '@mui/x-date-pickers-pro/AdapterDayjs';
import type {Dayjs} from 'dayjs';
import {CalendarIcon} from '../icons';
import {FlexBox} from '../layout';
import {Label} from '../text';

export type DateRangeValue = DateRange<Dayjs>;

type Props = {
  name?: string;
  label?: string;
  noOptionsPlaceholder?: string;
  // Only use undefined if component should be uncontrolled
  value: DateRangeValue | undefined;
  required?: boolean;
  disabled?: boolean;
  error?: boolean;
  onChange: (value: DateRangeValue | undefined) => void;
  onBlur?: () => void;
  shortcuts?: PickersShortcutsItem<DateRange<Dayjs>>[];
};

export const DateRangeField: React.FC<Props> = ({
  name,
  required,
  label,
  value,
  disabled = false,
  error = false,
  onChange,
  shortcuts,
}) => {
  /**
   * Display CalendarIcon if empty.
   * Display ClearIcon if not empty.
  const EndAdornment = useMemo(() => {
    if (!value || !value[0] || !value[1]) {
      return (
        <IconButton sx={{p: 0.5}}>
          <CalendarIcon />
        </IconButton>
      );
    }
    return (
      <IconButton sx={{p: 0.5}} onClick={() => onChange(undefined)}>
        <CloseIcon />
      </IconButton>
    );
  }, [onChange, value]);
   */

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'nb'}>
      <FlexBox>
        <Label>{label}</Label>
        <DateRangePicker
          disabled={disabled}
          onAccept={value => {
            onChange(value as DateRangeValue);
          }}
          defaultValue={value}
          calendars={2}
          slots={{
            openPickerIcon: CalendarIcon,
          }}
          slotProps={{
            shortcuts: {
              items: shortcuts,
            },
            actionBar: {
              actions: [],
            },
            textField: {
              variant: 'outlined',
              size: 'small',
              name,
              required,
              error,
            },
          }}
        />
      </FlexBox>
    </LocalizationProvider>
  );
};
